import List from './List'
import Create from './Create'
import Statistical from './Statistical'
import SummaryCard from './SummaryCard'

const CreditModules = {
    List,
    Create,
    Statistical,
    SummaryCard,
}

export default CreditModules
